import React,{useRef} from 'react';
import {Link} from 'react-router-dom';
import emailjs from '@emailjs/browser';
import swal from "sweetalert";
import { IMAGES, SVGICON } from '../constants/theme';

import twit from '../assets/images/social/twitter.png';
import facebook from '../assets/images/social/facebook.png';
import linkd from '../assets/images/social/linkedin.png';
import insta from '../assets/images/social/instagram.png';

const Footer = () => {
    const form = useRef();
	const sendEmail = (e) => {
		e.preventDefault();
		emailjs.sendForm('service_gfykn6i', 'template_iy1pb0b', e.target, 'HccoOtZS6GHw-N-m6')
		  .then((result) => {
			  console.log(result.text);
		  }, (error) => {
			  console.log(error.text);
		  });
		  e.target.reset()
		  swal('Good job!', 'form successfuly submmited', "success");
	};
    return (
        <>
            <footer className="site-footer">
                <div className="footer-top">
                    <div className="container">
                        
                        <div className="row">
                            <div className="col-lg-4 col-md-12 col-sm-12">
                                <div className="widget widget_about wow fadeInUp" data-wow-delay="0.4s">
                                    <h6 className="footer-title mb-3 ">Subscribe Our Newsletter</h6>
                                    <form className="dzSubscribe ft-subscribe mb-4"  ref={form} onSubmit={sendEmail}>
                                        <div className="dzSubscribeMsg"></div>
                                        <div className="input-group mb-0"> 
                                            <input name="dzEmail" required="required" type="email" className="form-control" placeholder="Your Email Address" />
                                            <button name="submit" value="Submit" type="submit" className="btn btn-primary style-1">
                                                {SVGICON.FooterArrow}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3 col-6">
                                <div className="widget widget_links wow fadeInUp" data-wow-delay="0.6s">
                                    <h6 className="footer-title">Our links</h6>
                                    <ul>
                                        <li><a href="#about-us">About Us </a></li>
                                        <li><a href="#contact-us">Contact Us </a></li>
                                    </ul>
                                </div>
                            </div>
                            {/* Blog links removed from footer */}
                            <div className="col-lg-2 col-md-3 col-6">
                                <div className="widget widget_links wow fadeInUp" data-wow-delay="1.2s">
                                    <h6 className="footer-title">Support</h6>
                                    <ul>
                                        <li><a href="#">FAQ</a></li>
                                        <li><a href="#contact-us">Contact us</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-3 col-6">
                                <div className="widget widget-social wow fadeInUp" data-wow-delay="1.4s">
                                    <h6 className="footer-title">Social</h6>
                                    <ul>
                                        <li><a target="_blank" href="https://twitter.com/mindrafttech" rel="noreferrer"><img src={twit} alt="" />Twitter</a></li>
                                        <li><a target="_blank" href="https://www.facebook.com/mindrafttech" rel="noreferrer"><img src={facebook} alt="" />Facebook</a></li>
                                        <li><a target="_blank" href="https://www.linkedin.com/in/mindrafttech" rel="noreferrer"><img src={linkd} alt="" />linkedin</a></li>
                                        <li><a target="_blank" href="https://www.instagram.com/mindrafttech/" rel="noreferrer"><img src={insta} alt="" />Instagram</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="container">
                        <div className="footer-inner text-center">
                            <p className="copyright-text wow fadeInUp" data-wow-delay="1.6s">Copyright 2023 by <a  href="https://Mindraft Tech.com/" target="_blank">Mindraft Tech</a>. All rights Reserved</p>
                        </div>
                    </div>
                </div>
            </footer>  
        </>
    );
};

export default Footer;